/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import withLocation from '#components/support/routing/withLocation/index.jsx';
import { fetchModel } from '#actions/models/model.js';
import { getExtractionJob, rehydrateExtractionJob } from '#actions/models/extractionJob.js';
import { chooseUploadReport } from '#actions/models/createModelFlow.js';
import { modelById } from '#selectors/entities/models.js';
import ExtractionProgress from './ExtractionProgress.jsx';

const mapStateToProps = (state, ownProps) => ({
  model: modelById(state, { modelId: ownProps.routeParams.modelId }),
});

const mapDispatchToProps = {
  fetchModel,
  getExtractionJob,
  rehydrateExtractionJob,
  chooseUploadReport,
};

export default pipe(
  connect(mapStateToProps, mapDispatchToProps),
  withNavigate,
  withRouteParams,
  withLocation
)(ExtractionProgress);
